/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ColumnMenu': {
    width: 6,
    height: 17,
    viewBox: '0 0 6 17',
    data: '<path pid="0" d="M3 4.124A2.041 2.041 0 1 0 3 .04a2.041 2.041 0 0 0 0 4.083zm0 1.843a2.041 2.041 0 1 0 0 4.083 2.041 2.041 0 0 0 0-4.083zm0 5.992a2.041 2.041 0 1 0 0 4.082 2.041 2.041 0 0 0 0-4.082z" _fill="#404040" fill-rule="nonzero"/>'
  }
})
